/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * * `ARMY` - Army
 * * `AIR_FORCE` - Air Force
 * * `MARINE_CORP` - Marine Corp
 * * `NAVY` - Navy
 * * `OTHER` - Other
 */
export enum MilitaryBranchEnum {
    ARMY = 'ARMY',
    AIR_FORCE = 'AIR_FORCE',
    MARINE_CORP = 'MARINE_CORP',
    NAVY = 'NAVY',
    OTHER = 'OTHER',
}
